/** Superposition draggable/redimensionnable d'un rendu généré sur la zone figée (B4). */
import { useRef, useState } from 'react';
import { X, Move } from 'lucide-react';

export const RenderOverlay = ({ src, onClose }) => {
  const [box, setBox] = useState({ x: window.innerWidth / 2 - 260, y: 120, w: 520 });
  const [opacity, setOpacity] = useState(0.85);
  const drag = useRef(null);

  const onDown = (e) => {
    drag.current = { sx: e.clientX, sy: e.clientY, x: box.x, y: box.y };
    const move = (ev) => setBox((b) => ({ ...b, x: drag.current.x + ev.clientX - drag.current.sx, y: drag.current.y + ev.clientY - drag.current.sy }));
    const up = () => { window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <div className="absolute z-[510]" style={{ left: box.x, top: box.y, width: box.w }}
         data-testid="render-overlay">
      <div className="flex items-center gap-2 px-2 h-8 rounded-t-lg cursor-grab active:cursor-grabbing select-none"
           style={{ background: 'rgba(10,10,13,0.9)', border: '1px solid var(--c-border-accent)', borderBottom: 'none' }}
           onPointerDown={onDown}>
        <Move className="w-3 h-3" style={{ color: 'var(--c-gold)' }} />
        <span className="text-[10px] font-bold uppercase tracking-wider" style={{ color: 'var(--c-gold)' }}>
          Calage du rendu
        </span>
        <input type="range" min={0.2} max={1} step={0.05} value={opacity}
               onChange={(e) => setOpacity(parseFloat(e.target.value))}
               onPointerDown={(e) => e.stopPropagation()}
               className="w-20 accent-amber-500 ml-1" data-testid="render-overlay-opacity" />
        <input type="range" min={220} max={1100} step={10} value={box.w}
               onChange={(e) => setBox((b) => ({ ...b, w: parseInt(e.target.value, 10) }))}
               onPointerDown={(e) => e.stopPropagation()}
               className="w-20 accent-amber-500" data-testid="render-overlay-scale" title="Échelle" />
        <button type="button" onClick={onClose} className="ml-auto" data-testid="render-overlay-close">
          <X className="w-3.5 h-3.5 text-gray-400 hover:text-white" />
        </button>
      </div>
      <img src={src} alt="rendu superposé" draggable={false}
           className="w-full block rounded-b-lg pointer-events-none"
           style={{ opacity, border: '1px solid var(--c-border-accent)', borderTop: 'none' }} />
    </div>
  );
};
